import { put } from 'redux-saga/effects';
import { BinderFormState } from 'components/ModalWindows/ManageBinder/binderFormReducer';
import { PdfPageOrder, UploadProjectType } from 'const';
import { uploadToPromoMats } from '../actions';

interface CreateBinderPayload {
  binderForm: BinderFormState;
  uploadProjectType: UploadProjectType;
  translationComplete: boolean;
  pdfPageOrder?: PdfPageOrder;
}

export function* createBinderAndUpload(action: { payload: CreateBinderPayload }): Generator {
  try {
    const { binderForm, uploadProjectType, translationComplete, pdfPageOrder } = action.payload;

    yield put(uploadToPromoMats(uploadProjectType, translationComplete, binderForm, pdfPageOrder));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in createBinderAndUpload saga:', error);
  }
}
